import axiosInstance from "./axiosConfig";

const settingsService = {
  // Get all settings including sizes
  getSettings: async () => {
    try {
      const response = await axiosInstance.get("/settings");
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Get only sizes
  getSizes: async () => {
    try {
      const response = await axiosInstance.get("/settings");
      if (response?.success && response?.data?.sizes) {
        return {
          success: true,
          data: response.data.sizes,
        };
      }
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export default settingsService;
